module.exports = __webpack_public_path__ + "static/media/9DESA28.4bdb72a7.jpg";